import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';

import type { CreditProfileType, RegisterCreditProfilePayload } from './types';

const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const syncCreditProfilePayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CreditProfileType>>();
const creditProfilePayloadCreator = getPayloadCreator<Record<string, any>>();
const registerCreditProfilePayloadCreator = getPayloadCreator<RegisterCreditProfilePayload>();
const deletePayloadCreator = getPayloadCreator<{ creditProfileRegistrationId?: string }>();

export const getCreditProfile = createAction('GET_CREDIT_PROFILE', getPayloadCreator());
export const getCreditProfileSuccess = createAction('GET_CREDIT_PROFILE_SUCCESS', syncCreditProfilePayloadCreator);
export const getCreditProfileFailure = createAction('GET_CREDIT_PROFILE_FAILURE', errorPayloadCreator);

export const createCreditProfile = createAction('CREATE_CREDIT_PROFILE', creditProfilePayloadCreator);
export const createCreditProfileSuccess = createAction('CREATE_CREDIT_PROFILE_SUCCESS', creditProfilePayloadCreator);
export const createCreditProfileFailure = createAction('CREATE_CREDIT_PROFILE_FAILURE', errorPayloadCreator);

export const registerCreditProfile = createAction('REGISTER_CREDIT_PROFILE', registerCreditProfilePayloadCreator);
export const pollRegisterCreditProfile = createAction(
  'POLL_REGISTER_CREDIT_PROFILE',
  registerCreditProfilePayloadCreator,
);
export const pollRegisterCreditProfileSuccess = createAction(
  'POLL_REGISTER_CREDIT_PROFILE_SUCCESS',
  syncCreditProfilePayloadCreator,
);
export const registerCreditProfileSuccess = createAction(
  'REGISTER_CREDIT_PROFILE_SUCCESS',
  syncCreditProfilePayloadCreator,
);
export const registerCreditProfileFailure = createAction('REGISTER_CREDIT_PROFILE_FAILURE', errorPayloadCreator);
export const verifyCreditProfileFailure = createAction('VERIFY_CREDIT_PROFILE_FAILURE', errorPayloadCreator);

export const resendVerificationRetry = createAction('RESEND_VERIFICATION_RETRY', registerCreditProfilePayloadCreator);
export const resendVerificationRetrySuccess = createAction(
  'RESEND_VERIFICATION_RETRY_SUCCESS',
  syncCreditProfilePayloadCreator,
);
export const resendVerificationRetryFailure = createAction('RESEND_VERIFICATION_RETRY_FAILURE', errorPayloadCreator);

export const deleteCreditProfile = createAction('DELETE_CREDIT_PROFILE', deletePayloadCreator);
export const deleteCreditProfileSuccess = createAction('DELETE_CREDIT_PROFILE_SUCCESS', creditProfilePayloadCreator);
export const deleteCreditProfileFailure = createAction('DELETE_CREDIT_PROFILE_FAILURE', errorPayloadCreator);
